<template>
  <div class="login">
    <div class="main">
      <div class="nthFirst"><img src="@/assets/img/loginSign.png" alt=""></div>
      <div class="nthSecond">园测信科门户网站后台管理工具</div>
      <div class="nthThird">欢迎登录</div>
      <div class="nthFourth"> <el-input class="inputHeight" style="" placeholder="请输入用户" suffix-icon="" v-model="form.userName">
          <template #prefix>
            <img src="@/assets/img/loginUser.png" alt="" style="width: 12px;height: 14px;line-height: 47px;margin-left: 5px;" />
          </template>
          <template #suffix>
            <!-- <img src="@/assets/img/userName.png" alt="" /> -->
          </template>

        </el-input></div>
      <div class="nthFifth"> <el-input class="inputHeight" :type="flagType" placeholder="请输入密码" v-model="form.password">
          <template #prefix>
            <img src="@/assets/img/loginPassword.png" alt="" style="width: 12px;height: 14px;line-height: 47px;margin-left: 5px;" />
          </template>
          <template #suffix>
            <img @click="getFlag()" src="@/assets/img/loginSeePassword.png" alt="" style="width: 12px;height: 6px;line-height: 47px;margin-right: 12px;" />
          </template>
        </el-input></div>
      <div class="nthSixth"> <el-button style="width: 100%;height: 100%;" type="primary" @click="primary">立即登录</el-button></div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/public.js"
export default {
  name: 'login',
  data() {
    return {
      form: {
        userName: '',
        password: ''
      },
      flag: false,
      flagType: 'password',
    }
  },
  methods: {
    clearCache() {
      const { matched } = this.$route
      const prevMatched = matched.slice(0, -1)
      const activated = matched[matched.length - 1]
      const prevActivated = prevMatched[prevMatched.length - 1]
      if (activated && activated.components.default === prevActivated.components.default) {
        this.$router.replace({ name: activated.name, params: activated.params, query: activated.query })
      }
    },
    primary() {
      if (!this.form.userName) {
        this.$message({
          message: '请输入账号',
          type: 'error'
        });
        return;
      }
      if (!this.form.userName) {
        this.$message({
          message: '请输入密码',
          type: 'error'
        });
        return;
      }

      login(this.form).then(res => {
        sessionStorage.setItem('token', res.data);
        this.$store.commit('setEditStatus', 0)
        this.$router.push('/home')
      })
    },
    getFlag() {
      console.log('sfs')
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/img/loginBackground.png");
  object-fit: cover;
}

.main {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  margin-right: 110px;
  margin-top: 293px;
  width: 518px;

  .nthFirst {
    width: 171px;
    height: 46px;
    margin-bottom: 16px;
  }

  .nthSecond {
    width: 100%;
    height: 35px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #115fad;
    margin-bottom: 23px;
  }

  .nthThird {
    width: 100%;
    height: 21px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #292929;
    margin-bottom: 54px;
  }

  .nthFourth {
    width: 385px !important;
    height: 47px;
    background: #ffffff;
    border: 1px solid #ced5dd;
    border-radius: 4px;
    margin-bottom: 19px;

    .inputHeight {
      height: 47px;
      line-height: 47px;
      border: none;
    }
  }

  .nthFifth {
    width: 385px !important;
    height: 47px;
    background: #ffffff;
    border: 1px solid #ced5dd;
    border-radius: 4px;
    margin-bottom: 61px;

    .inputHeight {
      height: 47px;
      line-height: 47px;
      border: none;
    }
  }

  .nthSixth {
    width: 385px;
    height: 47px;
    background: #2d72ff;
    border-radius: 4px;
  }
}

::v-deep .el-input__inner {
  border: 0px;
}

::v-deep .el-button--primary {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #ffffff;
}
</style>